import { render, staticRenderFns } from "./sinisters-specialists-admin.vue?vue&type=template&id=46dfaf47"
import script from "./sinisters-specialists-admin.vue?vue&type=script&lang=js"
export * from "./sinisters-specialists-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports